module.exports = __webpack_public_path__ + "img/nivel-ouro.6754e43e.svg";